export default "__VITE_ASSET__b54bc6c8__"